import { render, staticRenderFns } from "./ListWrap.vue?vue&type=template&id=98f49088&scoped=true"
import script from "./ListWrap.vue?vue&type=script&lang=js"
export * from "./ListWrap.vue?vue&type=script&lang=js"
import style0 from "./ListWrap.vue?vue&type=style&index=0&id=98f49088&prod&lang=scss&scoped=true"
import style1 from "./ListWrap.vue?vue&type=style&index=1&id=98f49088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f49088",
  null
  
)

export default component.exports